import EvCategoriesBase from './EvCategoriesBase';
import { compose, mdsWidget } from 'dojo/_base/declare';
import { MainCatalogTypes, MainCatalogs_Classes } from "../../_loadingHelpers/MainCatalogTypes";

class EvCategories_1_Editor extends compose(EvCategoriesBase) {
    
    //BASE
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.entityClass = MainCatalogs_Classes.EvCategory_1;
    }
    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(EvCategories_1_Editor);